<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModallLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createTaskModalLabel">{{$t('tasks.newTask')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="onSave" v-if="!isSaving">
                    <div class="modal-body">
                        <div v-if="showEditor" class="row">
                            <div class="col-md-12 bmd-form-group">
                                <div class="required font-weight-bold">{{$t('tasks.title')}}</div>
                                <input type="text" class="form-control" :name="'title'+_uid" v-validate="'required'" :data-vv-as="$t('tasks.title')" v-model="model.title" />
                                <span class="text-danger col-12" v-if="errors.has('title' + _uid)">{{ errors.first('title' + _uid) }}</span>
                            </div>
                            <div class="col-md-12 bmd-form-group">
                                <div class="font-weight-bold">{{$t('tasks.text')}}</div>
                                <textarea class="form-control" v-model="model.text" name="text" />
                            </div>
                            <div class="col-md-12 bmd-form-group">
                                <div class="required font-weight-bold">{{$t('tasks.assignees')}}</div>
                                <CoordinatorsList v-model="model.assignees"></CoordinatorsList>
                            </div>
                            <div class="col-md-12 bmd-form-group">
                                <div class="required font-weight-bold pb-2">{{$t('tasks.type')}}</div>
                                <!-- <NomDropdown v-model="model.typeId" type="Тип на задача" fieldName="Тип" :required="true"></NomDropdown> -->
                                <div id="task-type-choice">
                                    <label>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="optionsRadios" value="individual" v-model="model.typeId" checked />
                                                {{$t('tasks.individualTask')}}
                                            </label>
                                            <div class="text-info radio-message mb-2" v-if="model.type === 'individual'">
                                                <i class="fa fa-exclamation-circle"></i>
                                                {{$t('tasks.individualTaskMessage')}}
                                            </div>
                                        </div>
                                        <div class="radio">
                                            <label>
                                                <input type="radio" name="optionsRadios" value="group" v-model="model.typeId" />
                                                {{$t('tasks.groupTask')}}
                                            </label>
                                            <div class="text-info radio-message mb-2" v-if="model.type === 'group'">
                                                <i class="fa fa-exclamation-circle"></i>
                                                {{$t('tasks.groupTaskMessage')}}
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6 bmd-form-group">
                                <div class="required font-weight-bold">{{$t('tasks.priority')}}</div>
                                <NomDropdown v-model="model.priorityId" type="Приоритет на задача" fieldName="Приоритет" :required="true"></NomDropdown>
                            </div>
                            <div class="col-lg-6 bmd-form-group">
                                <div class="required font-weight-bold">{{$t('tasks.category')}}</div>
                                <NomDropdown v-model="model.categoryId" type="Категория на задача" fieldName="Категория" :required="true"></NomDropdown>
                            </div>
                            <div class="col-lg-6 bmd-form-group">
                                <div class="required font-weight-bold">{{$t('tasks.activity')}}</div>
                                <NomDropdown v-model="model.activityId" type="Тип дейност" :fieldName="$t('tasks.activity')" :required="true"></NomDropdown>
                            </div>
                            <div class="col-lg-6 bmd-form-group">
                                <div class="font-weight-bold">{{$t('tasks.deadline')}}</div>
                                <DatePicker v-model="model.deadline"
                                            format="dd.MM.yyyy H:mm"
                                            :min="new Date()"
                                            :data-vv-as="$t('tasks.deadline')"
                                            :error="errors.first($t('tasks.deadline'))"
                                            :fieldName="$t('tasks.deadline')"></DatePicker>
                            </div>
                            <div class="col-md-12 bmd-form-group">
                                <div class="font-weight-bold">{{$t('tasks.attachment')}}</div>
                                <div>
                                    <div class="mb-2" v-for="item in model.attachments" :key="_uid+item.fileName">
                                        <file-crud :file="item"
                                                   :showDescription="false"
                                                   @removeFile="onRemoveFile"
                                                   :editable="!item.id"
                                                   :type="item.docTypeCode">
                                        </file-crud>
                                    </div>

                                    <div v-if="!model.attachments.length || (model.attachments[model.attachments.length-1].content || model.attachments[model.attachments.length-1].id)">
                                        <button class="btn btn-primary ml-0" @click="addAtachment">
                                            <i class="fa fa-plus"></i>
                                            {{$t('add')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary" :disabled="!model.assignees.length">{{$t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.cancel')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from '../datepicker/DateTimePicker';
    import NomDropdown from '../dropdown/NomenclatureDropdown';
    import CoordinatorsList from '../coordinations/coordinators-list';
    import FileCrud from '../common/FileCRUD';
    import { File, Task } from '../../models/models';
    import tasksService from '../../services/tasks.service';

    export default {
        components: {
            DatePicker,
            NomDropdown,
            CoordinatorsList,
            FileCrud
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                model: new Task(),
                isSaving: false,
                showEditor: true
            };
        },
        methods: {
            onSave(e) {
                e.preventDefault();

                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.save();
                    }
                });
            },
            save() {
                this.isSaving = true;
                let data = new FormData();
                data.append('activityId', this.model.activityId);
                data.append('categoryId', this.model.categoryId);
                data.append('deadline', this.model.deadline ? new Date(this.model.deadline).toJSON() : '');
                data.append('priorityId', this.model.priorityId);
                data.append('priorityId', this.model.priorityId);
                data.append('text', this.model.text);
                data.append('title', this.model.title);
                data.append('typeId', this.model.typeId);

                // assignees
                for (let index = 0; index < this.model.assignees.length; index++) {
                    const element = this.model.assignees[index];
                    data.append(`assignees[${index}].userId`, element.userId);
                }

                // file
                if (this.model.attachments.length) {
                    for (let index = 0; index < this.model.attachments.length; index++) {
                        const attachment = this.model.attachments[index];
                        if (attachment.id) {
                            data.append(`attachments[${index}].id`, attachment.id);
                        } else {
                            data.append(`files`, attachment.content);
                        }
                    }
                }

                tasksService
                    .create(data)
                    .then(result => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('createSuccess'),
                            text: ''
                        });
                        this.$emit('created', this.model);
                        this.hide();
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    })
                    .then(() => (this.isSaving = false));
            },
            onClose() {
                this.model = new Task();
                this.isSaving = false;
                this.showEditor = false;
                this.$validator.reset();
                this.$emit('onClose', {});
            },
            hide() {
                $(this.$el).modal('hide');
            },
            mountModel() {
                $('#task-type-choice').bootstrapMaterialDesign();

                if (this.value) {
                    delete this.value.id;
                    this.model = new Task(this.value);
                }
            },
            addAtachment() {
                this.model.attachments.push(new File());
            },
            onRemoveFile(_id) {
                this.model.attachments = this.model.attachments.filter(x => x._id !== _id);
            }
        },
        computed: {
            minDate() {
                var currentDate = new Date();
                return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
            $(this.$el).on('shown.bs.modal', this.mountModel);

            if (this.value) {
                this.model = new Task(this.value);
            }
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
            $(this.$el).off('shown.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.showEditor = true;
                }
                this.model = new Task();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .radio-message {
        padding: 3px 3px 3px 5px;
        border-left: 3px solid #03a9f4;
        box-shadow: 1px 1px 1px 1px lightgrey;
    }

    div.radio label {
        color: inherit;
        cursor: pointer;
    }

    .bmd-form-group {
        padding-top: 1rem !important;
    }
</style>
